import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Footer.css';
import appLogo from '../../assets/appLogoHeader.png';
import apple from '../../assets/apple.png';
import android from '../../assets/android.png';

function Footer() {
  const { t } = useLanguage();
  
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer" id="footer">
      <div className="footer-border"></div>
      
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo">
              <img src={appLogo} alt="Quizzer Logo" />
              <p className="footer-slogan footer-slogan-white">{t('slogan')}</p>
            </div>
            
            <div className="footer-links">
              <div className="footer-links-column">
                <h3>{t('accueil')}</h3>
                <ul>
                  <li><a href="#categories">{t('themes')}</a></li>
                  <li><a href="#faq">FAQ</a></li>
                </ul>
              </div>
              
              <div className="footer-links-column centered-social">
                <h3>{t('social')}</h3>
                <ul className="social-links">
                  <li>
                    <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="social-link">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.9947 2H20.1957L13.3367 9.67111L21.4997 20H15.0997L10.0127 13.9422L4.22066 20H1.01666L8.31266 11.7911L0.499664 2H7.05666L11.6347 7.51556L16.9947 2ZM15.9947 18.2356H17.4927L6.09266 3.71556H4.45466L15.9947 18.2356Z" fill="currentColor"/>
                      </svg>
                      <span>X</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16 11.37C16.1234 12.2022 15.9813 13.0522 15.5938 13.799C15.2063 14.5458 14.5932 15.1514 13.8416 15.5297C13.0901 15.9079 12.2385 16.0396 11.4078 15.9059C10.5771 15.7723 9.80977 15.3801 9.21485 14.7852C8.61993 14.1902 8.22774 13.4229 8.09408 12.5922C7.96042 11.7615 8.09208 10.9099 8.47034 10.1584C8.8486 9.40685 9.4542 8.79374 10.201 8.40624C10.9478 8.01874 11.7978 7.87659 12.63 8C13.4789 8.12588 14.2649 8.52146 14.8717 9.12831C15.4785 9.73515 15.8741 10.5211 16 11.37Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="16.5" cy="7.5" r="1.5" fill="currentColor"/>
                      </svg>
                      <span>Instagram</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="social-link">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.6 5C16.4 5.5 16.8 5 16.6 5ZM17.6 8.2C18.5 8.9 19.6 9.4 20.7 9.5V12.7C19.6 12.6 18.5 12.3 17.5 11.7C16.8 11.3 16.2 10.9 15.6 10.3V15.8C15.6 16.7 15.4 17.6 15 18.4C14.4 19.7 13.2 20.7 11.9 21.1C11.1 21.4 10.3 21.5 9.5 21.3C7.7 21 6.2 19.7 5.6 18C5.4 17.4 5.3 16.8 5.3 16.2C5.3 13.7 7.3 11.7 9.8 11.7C10.2 11.7 10.6 11.8 11 11.9V15.1C10.8 15 10.6 14.9 10.4 14.9C9.4 14.8 8.5 15.5 8.4 16.4C8.3 17.3 8.9 18.2 9.8 18.4C10.7 18.6 11.6 18.1 11.9 17.3C12 17.1 12 16.9 12 16.7V3H15.2C15.2 3.2 15.2 3.4 15.3 3.6C15.5 5.1 16.4 6.4 17.6 7.3V8.2Z" fill="currentColor"/>
                      </svg>
                      <span>TikTok</span>
                    </a>
                  </li>
                </ul>
              </div>
              
              <div className="footer-links-column">
                <h3>{t('download')}</h3>
                <div className="download-buttons">
                  <button className="btn btn-download">
                    <img src={apple} alt="Apple" className="btn-icon" />
                    <span>{t('appstore')}</span>
                  </button>
                  <button className="btn btn-download">
                    <img src={android} alt="Android" className="btn-icon" />
                    <span>{t('googleplay')}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p className="copyright">© {currentYear} Quizzer. {t('droitsReserves')}</p>
            <div className="footer-legal">
              <a href="/terms" className="footer-link">{t('termsOfService')}</a>
              <span className="footer-separator">|</span>
              <a href="/privacy" className="footer-link">{t('privacyPolicy')}</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 